import { Day, VerifiedSiteLocation } from './types';

export enum SessionEnrollmentStatus {
  NotFull = 0,
  Waitlist = 1,
  Full = 2,
  Ended = 3,
}

export enum SessionBillingCycle {
  OneTime = 0,
  Weekly = 1,
  Monthly = 2
}

export enum DiscountUnitsEnum {
  FixedAmountDescription = 'amount',
  PercentageAmountDescription = 'percentage',
  FixedAmountSymbol = '$',
  PercentageAmountSymbol = '%'
}

export interface SessionDiscount {
  isApplied: boolean;
  unit: 'amount' | 'percentage' | 'Not set';
  /**
   * Value is the configured value set for the rule i.e 10% or $10
   */
  value: number;
  /**
   * Net value is the real discount that will be applied to the session, this will be calculated based on the unit and value
   * i.e for amount units the net value will be the same as the value, for percentage units the net value will be calculated based on the session price
   * also for multi participant discount the net value will be calculated based on the number of participants spread across the sessions
   */
  netItemDiscount: number;
}

export interface CatalogSession {
  programName: string;
  programId: number;
  sessionName: string;
  sessionId: number;
  note1: string;
  note2: string;
  startDateTime: string;
  endDateTime: string;
  isTimeAdded: boolean;
  selectedDays: Array<Day>;
  ageTo?: number;
  ageFrom?: number;
  ageAsOf?: string;
  // number of scholars currently on the session waitlist
  waitlistCount: number;
  // maximum number of scholars on the session waitlist; if undefined, indicates zero capacity
  waitlistCapacity?: number;
  // number of scholars currently enrolled in the session
  enrollmentCount: number;
  // maximum number of scholars enrolled in the session; if undefined, indicates unlimited capacity
  scholarCapacity?: number;
  price: number;
  priceId: string;
  sessionBillingCycle: SessionBillingCycle;
  billingCycleCount: number;
  siteLocationId?: number;
  siteLocation?: VerifiedSiteLocation;
  sessionEnrollmentStatus: SessionEnrollmentStatus;
  taxRateId?: string;
  taxRatePercentage: number;
  waitListIsUnlimited?: boolean | null;
  //new automatic discount entries
  discountPrice: number;
  earlyRegistrationDiscount: SessionDiscount;
  multiParticipantDiscount: SessionDiscount;
  multiParticipantDiscountPrice: number;
  //TODO: This should be a permanent value when having the payment-plans FF removed
  isPaymentPlanEnabled?: boolean;
  isPaymentPlanInCatalog?: boolean;
}

export interface CatalogSessionList {
  totalSetCount: number;
  count: number;
  results: Array<CatalogSession>;
}

export interface CatalogSessionFilters {
  accountId: number;
  sessions: Array<SessionFilterParameters>;
}

export interface SessionFilterParameters {
  sessionId: number;
  programId: number;
  programName: string;
  siteLocationId: number | null;
  siteLocationName: string | null;
  startDate: Date;
  endDate: Date;
}

export interface CatalogSessionListRequest {
  accountId: number;
  sessionIdList: Array<number>;
  page: number;
  count: number;
}

export interface FilterListItem {
  id: number;
  name: string;
  sessionIds: Array<number>;
}

export interface FilterListChangeData {
  checkedItem: FilterListItem;
  isAdded: boolean;
}

export enum PaymentOnboardingStatus {
  NotStarted = 1,
  Started = 2,
  Complete = 3,
}

export interface AccountPaymentOnboardingStatus {
  bxAccountId: number;
  onboardingStatus: PaymentOnboardingStatus;
}
